module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/9mill-inactive-a12f7b5abde246df9678574feeb94514.png";